import styled, { css } from 'styled-components';

export const WhatsappButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #25d366;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  text-decoration: none;

  &:hover {
    background-color: #1ebe5b;
  }

  svg {
    font-size: 18px;
  }
`;

export const BannerStyled = styled.div<{ $level: number }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;

  ${({ $level }) =>
    $level === 2
      ? css`
          background: #fff4e5;
          border: 1px solid #ffc069;
          color: #873800;
        `
      : css`
          background: #fffbe6;
          border: 1px solid #ffe58f;
          color: #614700;
        `}

  > svg {
    font-size: 22px;
    flex-shrink: 0;
  }
`;

export const BannerText = styled.span`
  flex: 1;
  min-width: 200px;
  line-height: 1.45;
`;

export const AckBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 8px 4px 0;

  p {
    margin: 0 0 8px;
    font-size: 15px;
    line-height: 1.5;
    color: #434343;
  }
`;

export const AckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fff4e5;
  color: #d46b08;
  font-size: 28px;
`;

export const AckTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #262626;
`;

export const BlockedLayer = styled.div`
  position: relative;
  min-height: calc(100vh - 120px);
`;

export const BlockedContent = styled.div`
  pointer-events: none;
  user-select: none;
  filter: blur(1.5px);
  opacity: 0.45;
`;

export const BlockedCard = styled.div`
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: min(440px, calc(100% - 32px));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 28px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);
  text-align: center;
  z-index: 10;
`;

export const BlockedIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fff1f0;
  color: #cf1322;
  font-size: 32px;
`;

export const BlockedTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #262626;
`;

export const BlockedText = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #434343;
`;
